<div class="mention-overlay"
     [style.top.px]="position.top"
     [style.left.px]="position.left">

  <div *ngIf="users.length > 0" class="mention-default-menu">
    <button class="mention-default-menu-item"
            *ngFor="let user of users; let i = index; trackBy: trackByFn"
            [class.active]="i === activeIndex"
            (click)="selectUser(user)"
            (mouseover)="onHover(i)">
      <clr-icon shape="user"></clr-icon>
      <div class="mention-menu-item-name">
        {{ user.firstName }} {{ user.lastName }}
      </div>
    </button>
  </div>

  <div *ngIf="users.length === 0" class="mention-default-menu">
    <button class="mention-default-menu-item"
         *ngFor="let user of defaultUsers"
        (click)="selectDefaultUser(user)">
      <clr-icon shape="user"></clr-icon>
      <div class="mention-menu-item-name">
        {{ user.firstName }} {{ user.lastName }}
      </div>
    </button>
    <button class="mention-default-menu-item"
            *ngFor="let team of defaultTeams"
            (click)="selectDefaultTeam(team)">
      <clr-icon shape="users"></clr-icon>
      <div class="mention-menu-item-name">
        {{ team.teamName }}
      </div>
      <div class="mention-default-menu-item-size">
        {{ team.teamSize }} {{ __('members') }}
      </div>
    </button>
  </div>
</div>
